import styled from 'styled-components';

export const NotificationsListHeader = styled.div`
  color: var(--argent);
  margin-top: 1rem;
`;
